import React from "react";
import {
  TableHead,
  TableRow,
  TableCell,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { getSelectorStyling, getMenuItemStyling } from "../Common/tableFilterStyles";

const SessionFilterHeader = ({
  activeFilter,
  onActiveFilterChange,
  recommendedFilter,
  onRecommendedFilterChange,
  duplicateFilter,
  onDuplicateFilterChange,
  premiumFilter,
  onPremiumFilterChange,
}) => {
  return (
    <TableHead>
      <TableRow sx={{
        backgroundColor: '#f5f5f5',
        '& .MuiTableCell-root': {
          padding: '6px 8px',
          fontSize: '0.8rem'
        }
      }}>
        <TableCell sx={{ fontWeight: 'bold', minWidth: 180, width: '24%' }}>Session Name</TableCell>
        <TableCell sx={{ fontWeight: 'bold', minWidth: 120, width: '16%' }}>Parent</TableCell>
        <TableCell align="center" sx={{ fontWeight: 'bold', minWidth: 80, width: '10%' }}>
          <FormControl size="small" sx={{
            ...getSelectorStyling(85)
          }}>
            <InputLabel>Active</InputLabel>
            <Select
              value={activeFilter}
              label="Active"
              onChange={onActiveFilterChange}
              sx={{ fontSize: '0.75rem' }}
            >
              <MenuItem value="all" sx={getMenuItemStyling()}>All</MenuItem>
              <MenuItem value="active" sx={getMenuItemStyling()}>Active</MenuItem>
              <MenuItem value="inactive" sx={getMenuItemStyling()}>Inactive</MenuItem>
            </Select>
          </FormControl>
        </TableCell>
        <TableCell align="center" sx={{ fontWeight: 'bold', minWidth: 80, width: '10%' }}>
          <FormControl size="small" sx={{
            ...getSelectorStyling(100)
          }}>
            <InputLabel>Recommended</InputLabel>
            <Select
              value={recommendedFilter}
              label="Recommended"
              onChange={onRecommendedFilterChange}
              sx={{ fontSize: '0.75rem' }}
            >
              <MenuItem value="all" sx={getMenuItemStyling()}>All</MenuItem>
              <MenuItem value="yes" sx={getMenuItemStyling()}>Yes</MenuItem>
              <MenuItem value="no" sx={getMenuItemStyling()}>No</MenuItem>
            </Select>
          </FormControl>
        </TableCell>
        <TableCell align="center" sx={{ fontWeight: 'bold', minWidth: 80, width: '10%' }}>
          <FormControl size="small" sx={{
            ...getSelectorStyling(85)
          }}>
            <InputLabel>Duplicate</InputLabel>
            <Select
              value={duplicateFilter}
              label="Duplicate"
              onChange={onDuplicateFilterChange}
              sx={{ fontSize: '0.75rem' }}
            >
              <MenuItem value="all" sx={getMenuItemStyling()}>All</MenuItem>
              <MenuItem value="yes" sx={getMenuItemStyling()}>Yes</MenuItem>
              <MenuItem value="no" sx={getMenuItemStyling()}>No</MenuItem>
            </Select>
          </FormControl>
        </TableCell>
        <TableCell align="center" sx={{ fontWeight: 'bold', minWidth: 80, width: '10%' }}>
          <FormControl size="small" sx={{
            ...getSelectorStyling(85)
          }}>
            <InputLabel>Premium</InputLabel>
            <Select
              value={premiumFilter}
              label="Premium"
              onChange={onPremiumFilterChange}
              sx={{ fontSize: '0.75rem' }}
            >
              <MenuItem value="all" sx={getMenuItemStyling()}>All</MenuItem>
              <MenuItem value="premium" sx={getMenuItemStyling()}>Premium</MenuItem>
              <MenuItem value="free" sx={getMenuItemStyling()}>Free</MenuItem>
            </Select>
          </FormControl>
        </TableCell>
        <TableCell align="center" sx={{ fontWeight: 'bold', minWidth: 60, width: '10%' }}>Author</TableCell>
        <TableCell align="right" sx={{ fontWeight: 'bold', minWidth: 80, width: '10%' }}>Actions</TableCell>
      </TableRow>
    </TableHead>
  );
};

export default SessionFilterHeader;
